import React, { useState, useEffect } from "react";
import { CourseBuilderStaticData } from "../../../../../../_constants/staticData";

const Quiz = ({
  quizCreation,
  setQuizCreation,
  history,
  next,
  quizValidateMsg,
  setQuizValidateMsg,
  updateQuizResponse,
}) => {
  const courseID = history?.location?.state?.courseId;

  const [quiz, setQuiz] = useState({
    title: false,
    instruction: false,
    multipleChoice: quizCreation.questions[0]?.question === null ? false : true,
    createQuestionType: [{ quizType: "" }],
  });
  const [addStatus, setAddStatus] = useState(null);
  const [questionIncrement, setQuestionIncrement] = useState(0);
  const [errors, setErrors] = useState({
    answers: [],
  });

  const addFormFields = (
    id,
    event,
    property,
    max,
    prevState,
    errors,
    value,
    accessor = null,
    object
  ) => {
    event.preventDefault();

    let clonedValues = [...quizCreation[object]];
    clonedValues[id]["answers"] = [...clonedValues[id][property], value];
    setQuizCreation({ ...quizCreation, questions: clonedValues });
  };

  const addCreateQuestion = (event, name, max, data, type) => {
    event.preventDefault();

    const optionStatus =
      quizCreation?.questions[quizCreation?.questions?.length - 1]?.answers;
    const optionResult = optionStatus?.map((items) => {
      if (items.isRight === true) {
        return true;
      }
      return false;
    });

    if (optionResult?.length >= 0) {
      setQuestionIncrement(questionIncrement + 1);
      let clonedValues = [...quizCreation["questions"]];
      let questions = [...clonedValues, data];
      setQuizCreation({ ...quizCreation, questions });
      setAddStatus(null);
    } else setAddStatus("Please choose any one right answer");
  };

  const removeFormFields = (id, event, index, property, name) => {
    event.preventDefault();
    let getID = [...quizCreation[`questions`][id][property]];
    let newquizCreation = [...getID];
    newquizCreation.splice(index, 1);

    const clonedValues = { ...quizCreation };
    clonedValues[`questions`][id][property] = newquizCreation;

    setQuizCreation(clonedValues);
  };

  const handleInputChange = (
    id,
    index,
    name,
    value,
    accessor = null,
    object
  ) => {
    let test = { ...quizCreation[object] };
    let clonedValues = [...test[id][name]];
    bindquizCreation(index, value, clonedValues, accessor);

    const prevState = { ...quizCreation };
    prevState[object][id][name] = clonedValues;
    setQuizCreation(prevState);
  };
  const bindquizCreation = (index, value, items, accessor = null) => {
    accessor ? (items[index][accessor] = value) : (items[index] = value);
    return items;
  };

  const inputHandler = (e) => {
    const name = e.target.name;
    const values = e.target.value;
    setQuizCreation({ ...quizCreation, [name]: values });
  };

  const questionDelete = (id, object) => {
    let getID = { ...quizCreation };
    let questions = [...getID[object]];
    questions.splice(id, 1);
    let values = { ...quizCreation, questions };
    setQuizCreation(values);
    setQuestionIncrement(questionIncrement - 1);
  };

  const checkInputHandler = (
    id,
    index,
    name,
    value,
    accessor = null,
    object
  ) => {
    let clonedValues = [...quizCreation[`questions`]];
    setQuizCreation({
      ...quizCreation,
      [name]: bindquizCreation(index, value, clonedValues, accessor),
    });
  };

  useEffect(() => {
    if (courseID) {
      setQuizCreation({
        ...quizCreation,
        [`id`]: courseID,
      });
    }
  }, [courseID]);

  const handleCreateQuestion = () => {
    if (quizCreation?.name === "") {
      setQuizValidateMsg(true);
    } else {
      setQuiz({ ...quiz, multipleChoice: !quiz.multipleChoice });
    }
  };

  const optionStatus = (isRight, questionIndex, answerIndex, type) => {
    const thisAnswers = quizCreation["questions"][questionIndex]["answers"];
    const rightAnswerIndex = thisAnswers.findIndex((item) => item.isRight);
    if (type.toString() !== "3" && rightAnswerIndex > -1) {
      if (rightAnswerIndex === answerIndex) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <div className="quizSection-container">
        <div className="innerQuiz-button">
          <button
            className="btn-1"
            onClick={() => setQuiz({ ...quiz, title: !quiz.title })}
          >
            {`${CourseBuilderStaticData.step18.buttonText1}${
              quiz.title ? "-" : "+"
            }`}
          </button>
          {quiz.title && (
            <div className="show-item">
              <input
                type="text"
                name="name"
                value={quizCreation.name}
                className="custom-input"
                onChange={(e) => inputHandler(e)}
              />
            </div>
          )}
        </div>
        <div className="innerQuiz-button">
          <button
            className="btn-1"
            onClick={() => setQuiz({ ...quiz, instruction: !quiz.instruction })}
          >
            {`${CourseBuilderStaticData.step18.buttonText2}
            ${quiz.instruction ? "-" : "+"}`}
          </button>
          {quiz.instruction && (
            <div className="show-item">
              <textarea
                id="w3review"
                name="guidelines"
                rows="4"
                cols="50"
                value={quizCreation.guidelines}
                onChange={(e) => inputHandler(e)}
                className="custom-input"
              />
            </div>
          )}
        </div>
        <div className="innerQuiz-button">
          <button
            className="btn-3 create-question"
            onClick={handleCreateQuestion}
          >
            Create Question 1
          </button>
        </div>
        {quizCreation?.name === "" && quizCreation?.guidelines === "" ? (
          <div>
            {quizValidateMsg && (
              <div className="quiz-eveny-0">
                <div
                  className="quiz-popup"
                  onClick={() => setQuizValidateMsg(!quizValidateMsg)}
                >
                  <i className="icon check"></i>
                </div>
                {quizCreation?.name === "" &&
                quizCreation?.guidelines === "" ? (
                  <p>
                    Please fill title and instructions/guidelines of the quiz.
                  </p>
                ) : (
                  <p>{updateQuizResponse}</p>
                )}
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="multipleChoice-section">
        {quizCreation?.questions?.map((element, id) => (
          <>
            {quiz?.multipleChoice && (
              <>
                {element?.type === null && (
                  <div className="multipleChoice-section">
                    <ul>
                      <li>
                        <input
                          type="radio"
                          name="questions"
                          value={1}
                          onChange={({ target }) =>
                            checkInputHandler(
                              id,
                              id,
                              target.name,
                              target.value,
                              "type",
                              "type",
                              "type"
                            )
                          }
                        />
                        <label>Multiple Choice Questions</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="questions"
                          value={3}
                          onChange={({ target }) =>
                            checkInputHandler(
                              id,
                              id,
                              target.name,
                              target.value,
                              "type",
                              "type",
                              "type"
                            )
                          }
                        />
                        <label>
                          Multiple Select Questions(more than 1 correct answer)
                        </label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="questions"
                          value={2}
                          onChange={({ target }) =>
                            checkInputHandler(
                              id,
                              id,
                              target.name,
                              target.value,
                              "type",
                              "type",
                              "type"
                            )
                          }
                        />
                        <label>Fill in the Gaps/Blanks</label>
                      </li>
                      <li
                        style={{ backgroundColor: "#cecece", color: "white" }}
                      >
                        <input
                          type="radio"
                          name="questions"
                          value="Detailed Q&A"
                          disabled={true}
                          onChange={({ target }) =>
                            checkInputHandler(
                              id,
                              id,
                              target.name,
                              target.value,
                              "type",
                              "type",
                              "type"
                            )
                          }
                        />
                        <label>Detailed Q&A</label>
                      </li>
                    </ul>
                  </div>
                )}
              </>
            )}

            {element?.type !== null && (
              <div className="quizCreationMapped">
                <h4 style={{ fontWeight: 500 }}> Question {id + 1} </h4>
                {id > 0 && (
                  <div className="quizCreation-id">
                    <img
                      name="answers"
                      className=""
                      onClick={(event) => questionDelete(id, "questions")}
                      src="https://cdn.edusity.com/icons/icon-trash.svg"
                      alt=""
                    />
                  </div>
                )}
                <div className="show-item">
                  <textarea
                    name="questions"
                    rows="4"
                    cols="50"
                    value={element.question}
                    className="custom-input"
                    onChange={({ target }) =>
                      checkInputHandler(
                        id,
                        id,
                        target.name,
                        target.value,
                        "question",
                        "question"
                      )
                    }
                  />
                </div>
                <h4 style={{ fontWeight: 500 }}>
                  {element?.type === "Simple MCQ"
                    ? "Options Choices"
                    : "Answer"}
                </h4>
                <div className="define-add-input">
                  {element?.answers?.map((item, index) => (
                    <>
                      {element.type === "Detailed Q&A" && (
                        <textarea
                          name="questions"
                          rows="4"
                          cols="50"
                          value={element.question}
                          className="custom-input"
                          onChange={({ target }) =>
                            checkInputHandler(
                              id,
                              id,
                              target.name,
                              target.value,
                              "question",
                              "question"
                            )
                          }
                        />
                      )}

                      <div className="form-inline" key={index}>
                        {element.type !== "Detailed Q&A" && (
                          <>
                            <input
                              type="text"
                              className={
                                errors.answers.filter(
                                  (item) => item.id === index
                                ).length > 0
                                  ? "error"
                                  : ""
                              }
                              name="answers"
                              placeholder={`Options${index + 1}`}
                              value={item.answer}
                              onChange={({ target }) =>
                                handleInputChange(
                                  id,
                                  index,
                                  target.name,
                                  target.value,
                                  "answer",
                                  "questions"
                                )
                              }
                            />

                            <div className="quiz-Options">
                              <input
                                type="checkbox"
                                name={"answers"}
                                value={item.isRight === false ? true : false}
                                checked={item.isRight}
                                disabled={optionStatus(
                                  item.isRight,
                                  id,
                                  index,
                                  element?.type
                                )}
                                style={{ width: "20px", marginTop: "10px" }}
                                onChange={({ target }) =>
                                  handleInputChange(
                                    id,
                                    index,
                                    target.name,
                                    item.isRight === false ? true : false,
                                    "isRight",
                                    "questions"
                                  )
                                }
                              />
                              <label>This is Correct</label>
                            </div>
                          </>
                        )}

                        {index > 0 && (
                          <img
                            href="javascript(void);"
                            name="answers"
                            className="align-textRemove quiz"
                            onClick={(event) =>
                              removeFormFields(
                                id,
                                event,
                                index,
                                event.target.name,
                                "answer",
                                "questions"
                              )
                            }
                            src="https://cdn.edusity.com/icons/icon-trash.svg"
                            alt=""
                          />
                        )}
                      </div>
                      {/* )} */}
                    </>
                  ))}
                </div>
                {element.type !== "Detailed Q&A" && (
                  <div className="define-add-text addQuiz-section">
                    <a
                      href="javascript(void);"
                      name="answers"
                      className="addQuiz-More"
                      onClick={(event) =>
                        addFormFields(
                          id,
                          event,
                          event.target.name,
                          5,
                          quizCreation,
                          errors,
                          { answer: "", isRight: false },
                          true,
                          "questions"
                        )
                      }
                    >
                      Add More Options
                    </a>
                  </div>
                )}
              </div>
            )}
          </>
        ))}
        <span className="add-status-quiz-valid">{addStatus}</span>
        {quizCreation?.questions[questionIncrement]?.question !== null &&
          quizCreation?.questions?.length > 0 && (
            <div className="innerQuiz-button">
              <button
                className="btn-3 create-question"
                onClick={(event) =>
                  addCreateQuestion(event, "quiz", 10, {
                    question: null,
                    type: null,
                    answers: [{ answer: "", isRight: false }],
                  })
                }
              >
                {` Create Question ${quizCreation?.questions?.length + 1}`}
              </button>
            </div>
          )}
      </div>
    </>
  );
};

export default Quiz;
